import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  "data-name": "Layer 1",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#00ac47\" d=\"M23.75 16a7.745 7.745 0 0 1-15.032 2.626l-4.433 3.546A13.244 13.244 0 0 0 29.25 16\"></path><path fill=\"#4285f4\" d=\"M23.75 16a7.74 7.74 0 0 1-3.252 6.299l4.383 3.506A13.2 13.2 0 0 0 29.25 16\"></path><path fill=\"#ffba00\" d=\"M8.25 16a7.7 7.7 0 0 1 .468-2.626L4.285 9.828a13.18 13.18 0 0 0 0 12.344l4.433-3.546A7.7 7.7 0 0 1 8.25 16\"></path><path fill=\"#2ab2db\" d=\"M8.718 13.374\"></path><path fill=\"#ea4435\" d=\"M16 8.25a7.7 7.7 0 0 1 4.558 1.496l4.06-3.79A13.215 13.215 0 0 0 4.285 9.828l4.433 3.546A7.76 7.76 0 0 1 16 8.25\"></path><path fill=\"#2ab2db\" d=\"M8.718 18.626\"></path><path fill=\"#4285f4\" d=\"M29.25 15v1L27 19.5H16.5V14h11.75a1 1 0 0 1 1 1\"></path>", 7)
  ]))]))
}
export default { render: render }